import { styled, css } from '@mui/material/styles';
import {
  Box,
  MenuItem as MenuItemStyles,
  Button as Btn,
  Typography,
} from '@mui/material';

export const HeaderDrawer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #bdbdbd;
  padding: 0px 0px 16px;
  position: relative;

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #000000;
  }
`;

export const Text = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 28px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;
  color: #212121;
`;

export const Users = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0px;
  gap: 100px;

  width: 100%;
  height: 62px;

  border-top: 1px solid #e0e0e0;
  border-radius: 4px;

  cursor: pointer;

  :hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  .name {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
  }
`;

export const Container = styled(Box)`
  height: 100%;
  width: 100%;
  overflow-y: auto;
  background: #f5f5f5;
  padding: 42px 30px;
  z-index: 1;
`;

export const Button = styled(Btn)``;

export const Header = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 20px;

  width: 100%;
  height: 48px;

  .Mui-disabled {
    cursor: not-allowed !important;
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: '#FFFFF' !important;
    border: none !important;
  }

  .section-tabs {
    display: flex;
    padding-top: 8px;
    gap: 10px;
    padding-bottom: 8px;
    align-items: center;
  }
  .btn-archives {
    height: 42px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.54);
    white-space: nowrap;
    border-radius: 0px;
  }
  .btn-files {
    height: 42px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.54);
    white-space: nowrap;
    border-radius: 0px;
  }
  .new-file {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    gap: 10px;
    width: 160px;
    height: 48px;
    background-color: ${({ theme }) => theme.palette.primary.main};
    color: #ffffff;
    font-size: 15px;
    white-space: nowrap;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    line-height: 14px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }
`;

export const Filters = styled(Box)``;
export const Div = styled(Box)``;
export const Table = styled(Box)``;
export const TableContent = styled(Box)`
  li {
    list-style: none;
    display: flex;
    align-items: center;
    height: 41px;
    border-top: 1.8px solid #323232;
    border-bottom: 1.8px solid #323232;
    padding: 0px 40px 0px 40px;
    justify-content: space-between;
    gap: 25px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;

    a {
      display: flex;
      align-items: center;
      gap: 25px;
    }
  }
  li:hover {
    background-color: #e9e9e9;
    cursor: pointer;
  }
  ul {
    padding: 0;
    display: flex;
    width: 100%;
    flex-direction: column;
    margin: 0;
    gap: 10px;
  }
`;
export const HeaderTable = styled(Box)`
  width: 50%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  padding: 5px 0px 5px 60px;
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 16px;
`;
export const HeaderPage = styled(Box)``;

export const BreadCrumbContainer = styled(Box)`
  display: flex;
  align-items: center;
`;

export const BreadCrumbBox = styled(Box)`
  margin-left: 5px;

  strong {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000;
    text-transform: capitalize;
    cursor: pointer;

    :hover {
      color: #0b79d0;
    }
  }
`;

export const Page = styled(Box)`
  width: 100%;
  padding-top: 20px;
`;

export const CardBackSection = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 15px;
  width: 100%;
  height: 60px;
  background: #ffffff;
  border-radius: 6px;
  gap: 10px;

  :hover {
    background-color: #e9e9e9;
    cursor: pointer;
  }

  cursor: pointer;
  span {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
  }
`;

export const ContainerButtons = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 7px;
  padding-right: 10px;
`;

export const Content = styled(Box)`
  .header-guests {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 25px 20px 20px 20px;
    align-items: center;
  }

  .btn-save-guest {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 10px;
    width: 70px;
    height: 36px;
    /* background: rgba(0, 0, 0, 0.12); */
    border-radius: 4px;
  }
  .input-container {
    height: 42px;
    margin: 0px 20px 20px 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .name-filter {
    width: 100%;
    height: 42px;
    border: 1px solid #4c4c4c;
    border-radius: 5px;

    padding: 8px 50px;
    opacity: 0.5;

    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    /* identical to box height, or 200% */

    display: flex;
    align-items: center;

    /* Grey/Off Black */

    color: #0e0e2c;
  }
`;
export const SubHeader = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  margin: 0px 20px 20px 20px;

  height: 48px;
  background: ${({ theme }) => theme.palette.common.white};
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12);

  .members {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 33px;
    gap: 10px;
    border-radius: 0;

    width: 160px;
    height: 48px;

    /* White */

    background: ${({ theme }) => theme.palette.common.white};
  }
  .groups {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 33px;
    gap: 10px;
    border-radius: 0;

    width: 160px;
    height: 48px;

    /* White */

    background: ${({ theme }) => theme.palette.common.white};
  }
`;
interface TabSelected {
  active: boolean;
}
export const ButtonMembers = styled(Btn)`
  ${(props: TabSelected) =>
    props.active &&
    css`
      border-bottom: 2px solid #206da7;
    `}
`;

export const TextCheckBox = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: #616161;
  white-space: nowrap;
  padding: 10px;
`;
